export const getDiagnosticData = (data) => {
    const studentName =
        data?.school_card_report?.scanned_name &&
        data?.school_card_report?.scanned_name !== "NonTrouvé"
            ? data?.school_card_report?.scanned_name
            : "l'élève"
    const style = data?.school_card_report?.style_classification
    const prioritySubject =
        data?.weakest_subject_analysis?.subject_name?.toLowerCase() || ""

    const championVariant = {
        1: "unhappy",
        2: "unhappy",
        3: "main",
        4: "happy",
    }

    return [
        {
            title: "Performance",
            isPillar: true,
            colors: ["#FFFFFF", "#F3A341"],
            icon: require("../../../assets/diagnostic/performance/finish-flag.png"),
            score: data?.school_card_report?.performance_score,
            subtitle: {
                1: "Bas de tableau",
                2: "Peloton",
                3: "Peloton de tête",
                4: "Sprinteur",
            },
            comment: data?.school_card_report?.performance_diagnosis,
            champion: "zoe",
            championVariant,
            seeMore: "school-card-report/diagnostic/performance/ranking",
        },
        {
            title: "Motivation",
            isPillar: true,
            colors: ["#FFFFFF", "#0084FF"],
            icon: {
                1: require("../../../assets/diagnostic/motivation/beach-umbrella.png"),
                2: require("../../../assets/diagnostic/motivation/plane.png"),
                3: require("../../../assets/diagnostic/motivation/compass.png"),
                4: require("../../../assets/diagnostic/motivation/shuttle.png"),
            },
            score: data?.school_card_report?.motivation_score,
            subtitle: {
                1: "Touriste",
                2: "Mode automatique",
                3: "Aventurier",
                4: "Geek en puissance",
            },
            comment: {
                1: "L'élève avance sans trop se poser de questions, fait le strict minimum pour éviter la casse.",
                2: "L'élève avance sans trop se poser de questions, fait le strict minimum pour éviter la casse.",
                3: "L'élève est curieux, explore les notions, cherche à progresser et ne recule pas devant un défi.",
                4: "L'élève adore apprendre, pose mille questions et pourrait presque faire des exposés pour le plaisir !",
            },
            champion: "abou",
            championVariant,
            seeMore: "school-card-report/diagnostic/motivation/see-more",
            buttonText: "Voir les avis des profs",
        },
        {
            title: "Organisation",
            isPillar: true,
            colors: ["#FFFFFF", "#00BCD4"],
            icon: {
                1: require("../../../assets/diagnostic/organisation/windstorm.png"),
                2: require("../../../assets/diagnostic/organisation/hourglass.png"),
                3: require("../../../assets/diagnostic/organisation/book.png"),
                4: require("../../../assets/diagnostic/organisation/trophy.png"),
            },
            score: data?.school_card_report?.organization_score,
            subtitle: {
                1: "Désordonné",
                2: "Improvisateur",
                3: "Méthodique",
                4: "Rigoureux",
            },
            comment: {
                1: "L'élève oublie souvent ses devoirs, ses affaires sont éparpillées, et il/elle peine à s'y retrouver",
                2: "L'élève s'organise au dernier moment, fait les choses un peu en vitesse, mais finit par s'en sortir.",
                3: "L'élève suit un certain ordre, planifie ses tâches et parvient à bien gérer son travail.",
                4: "L'élève est extrêmement organisé, anticipe tout, et maîtrise son emploi du temps à la perfection.",
            },
            champion: "sam",
            championVariant,
            seeMore: "school-card-report/diagnostic/bullet-points/see-more",
            buttonText: "Voir nos conseils",
        },
        {
            title: "Style",
            colors: ["#F9D1C0", "#D0A7E9"],
            isPillar: false,
            style: style,
            icon: {
                généraliste: require("../../../assets/diagnostic/style/balance.png"),
                scientifique: require("../../../assets/diagnostic/style/flask.png"),
                littéraire: require("../../../assets/diagnostic/style/open-book.png"),
                linguiste: require("../../../assets/diagnostic/style/parchment.png"),
                nonchalant: require("../../../assets/diagnostic/style/sunbathing.png"),
            },
            subtitle: style.charAt(0).toUpperCase() + style.slice(1),
            subtitleColor: "#335D76",
            comment: data?.school_card_report?.style_arguments?.[0]?.argument,
            champion: "tina",
            championVariant: "main",
            seeMore: "school-card-report/diagnostic/style/see-more",
        },
        {
            title: "Matière Prioritaire",
            colors: ["#FFFFFF", "#D3AE41"],
            isPillar: false,
            icon: require("../../../assets/diagnostic/priority/warning.png"),
            prioritySubject: prioritySubject,
            subtitle:
                prioritySubject.charAt(0).toUpperCase() +
                prioritySubject.slice(1),
            subtitleColor: "#AD2311",
            level: data?.weakest_subject_analysis?.level,
            comment: {
                débutant: `${studentName} a eu une note de ${data?.weakest_subject_analysis?.student_average} en moyenne en ${prioritySubject} ce trimestre. On doit revoir les bases pour progresser !`,
                intermédiaire: `${studentName} a eu une note de ${data?.weakest_subject_analysis?.student_average} en moyenne en ${prioritySubject} ce trimestre. On peut faire mieux !`,
                avancé: `${studentName} a eu une note de ${data?.weakest_subject_analysis?.student_average} en moyenne en ${prioritySubject} ce trimestre. On peut viser l'excellence !`,
            },
            champion: "zoe",
            championVariant: "main",
            seeMore: "school-card-report/diagnostic/bullet-points/see-more",
        },
        {
            title: "Objectif pour le Prochain Trimestre",
            colors: ["#FFFFFF", "#8BC34A"],
            isPillar: false,
            icon: require("../../../assets/diagnostic/objectif/target.png"),
            subtitle: `Progresser en ${prioritySubject} !`,
            subtitleColor: "#2AA0DB",
            comment: `Nous avons identifié ${data?.weakest_subject_analysis?.objectif_actions?.length} actions à mettre en place avant chaque contrôle de ${prioritySubject} pour y parvenir.`,
            champion: "abou",
            championVariant: "main",
            seeMore: "school-card-report/diagnostic/bullet-points/see-more",
            buttonText: "Voir le plan d'action",
        },
    ]
}

export const getMockDiagnosticData = () => {
    const style = "littéraire"
    const prioritySubject = "mathématiques"

    const championVariant = {
        1: "unhappy",
        2: "unhappy",
        3: "main",
        4: "happy",
    }

    return [
        {
            title: "Performance",
            isPillar: true,
            colors: ["#FFFFFF", "#F3A341"],
            icon: require("../../../assets/diagnostic/performance/finish-flag.png"),
            score: 1,
            subtitle: {
                1: "Bas de tableau",
                2: "Peloton",
                3: "Peloton de tête",
                4: "Sprinteur",
            },
            comment:
                "L'élève est en dessous de la moyenne de sa classe dans 7/12 matières. L'élève peut mieux faire...",
            champion: "zoe",
            championVariant,
            seeMore: "school-card-report/diagnostic/performance/ranking",
        },
        {
            title: "Motivation",
            isPillar: true,
            colors: ["#FFFFFF", "#0084FF"],
            icon: {
                1: require("../../../assets/diagnostic/motivation/beach-umbrella.png"),
                2: require("../../../assets/diagnostic/motivation/plane.png"),
                3: require("../../../assets/diagnostic/motivation/compass.png"),
                4: require("../../../assets/diagnostic/motivation/shuttle.png"),
            },
            score: 3,
            subtitle: {
                1: "Touriste",
                2: "Mode automatique",
                3: "Aventurier",
                4: "Geek en puissance",
            },
            comment: {
                1: "L'élève avance sans trop se poser de questions, fait le strict minimum pour éviter la casse.",
                2: "L'élève avance sans trop se poser de questions, fait le strict minimum pour éviter la casse.",
                3: "L'élève est curieux, explore les notions, cherche à progresser et ne recule pas devant un défi.",
                4: "L'élève adore apprendre, pose mille questions et pourrait presque faire des exposés pour le plaisir !",
            },
            champion: "abou",
            championVariant,
            seeMore: "school-card-report/diagnostic/motivation/see-more",
            buttonText: "Voir les avis des profs",
        },
        {
            title: "Organisation",
            isPillar: true,
            colors: ["#FFFFFF", "#00BCD4"],
            icon: {
                1: require("../../../assets/diagnostic/organisation/windstorm.png"),
                2: require("../../../assets/diagnostic/organisation/hourglass.png"),
                3: require("../../../assets/diagnostic/organisation/book.png"),
                4: require("../../../assets/diagnostic/organisation/trophy.png"),
            },
            score: 2,
            subtitle: {
                1: "Désordonné",
                2: "Improvisateur",
                3: "Méthodique",
                4: "Rigoureux",
            },
            comment: {
                1: "L'élève oublie souvent ses devoirs, ses affaires sont éparpillées, et il/elle peine à s'y retrouver",
                2: "L'élève s'organise au dernier moment, fait les choses un peu en vitesse, mais finit par s'en sortir.",
                3: "L'élève suit un certain ordre, planifie ses tâches et parvient à bien gérer son travail.",
                4: "L'élève est extrêmement organisé, anticipe tout, et maîtrise son emploi du temps à la perfection.",
            },
            champion: "sam",
            championVariant,
            seeMore: "school-card-report/diagnostic/bullet-points/see-more",
            buttonText: "Voir nos conseils",
        },
        {
            title: "Style",
            colors: ["#F9D1C0", "#D0A7E9"],
            isPillar: false,
            style: style,
            icon: {
                généraliste: require("../../../assets/diagnostic/style/balance.png"),
                scientifique: require("../../../assets/diagnostic/style/flask.png"),
                littéraire: require("../../../assets/diagnostic/style/open-book.png"),
                linguiste: require("../../../assets/diagnostic/style/parchment.png"),
                nonchalant: require("../../../assets/diagnostic/style/sunbathing.png"),
            },
            subtitle: style.charAt(0).toUpperCase() + style.slice(1),
            subtitleColor: "#335D76",
            comment: "L'élève est 3 fois meilleur en anglais qu'en math !",
            champion: "tina",
            championVariant: "main",
            seeMore: "school-card-report/diagnostic/style/see-more",
        },
        {
            title: "Matière Prioritaire",
            colors: ["#FFFFFF", "#D3AE41"],
            isPillar: false,
            icon: require("../../../assets/diagnostic/priority/warning.png"),
            prioritySubject,
            subtitle:
                prioritySubject.charAt(0).toUpperCase() +
                prioritySubject.slice(1),
            subtitleColor: "#AD2311",
            level: "débutant",
            comment: {
                débutant:
                    "Sa note la plus faible est 5/20 en Maths ! Il ne maîtrise pas les compétences fondamentales de cette matière !",
                intermédiaire:
                    "Sa note la plus faible est 5/20 en Maths ! Il ne maîtrise pas les compétences fondamentales de cette matière !",
                avancé: "Sa note la plus faible est 5/20 en Maths ! Il ne maîtrise pas les compétences fondamentales de cette matière !",
            },
            champion: "zoe",
            championVariant: "main",
            seeMore: "school-card-report/diagnostic/bullet-points/see-more",
        },
        {
            title: "Objectif pour le Prochain Trimestre",
            colors: ["#FFFFFF", "#8BC34A"],
            isPillar: false,
            icon: require("../../../assets/diagnostic/objectif/target.png"),
            subtitle: "Passer de 5 à 11",
            subtitleColor: "#2AA0DB",
            comment:
                "Nous avons identifié 4 actions à mettre en place avant chaque contrôle de maths pour y parvenir.",
            champion: "abou",
            championVariant: "main",
            seeMore: "school-card-report/diagnostic/bullet-points/see-more",
            buttonText: "Voir le plan d'action",
        },
    ]
}

export const getPerformanceRankingData = (data) => {
    if (!data?.subject_analysis) {
        return []
    }

    return data?.subject_analysis
        .filter((subject) => subject?.subject_name !== "NonTrouvé")
        .map((subject) => {
            return {
                subject: subject?.subject_name,
                moyClasse: parseFloat(subject?.class_average),
                moyStudent: parseFloat(subject?.student_average) || 10,
            }
        })
}

export const getMotivationSeeMoreData = (data) => {
    const remarks = data?.school_card_report?.motivation_supporting_remarks
    const studentName =
        data?.school_card_report?.scanned_name !== "NonTrouvé"
            ? data?.school_card_report?.scanned_name
            : "l'élève"

    const formattedData = remarks.map((remark, index) => {
        return {
            _id: index + 1,
            user: {
                _id: index % 2 === 0 ? 1 : 2,
                name:
                    remark?.professor && remark?.professor !== "NonTrouvé"
                        ? remark?.professor
                        : "Professeur",
            },
            text: `"${remark?.remark || ""}"`,
        }
    })

    return { formattedData, studentName }
}

export const getBulletPointsSeeMoreData = (data, page) => {
    switch (page) {
        case 3:
            // eslint-disable-next-line no-case-declarations
            let advices = data?.school_card_report?.organization_advices

            if (
                typeof advices === "string" &&
                advices.startsWith("[") &&
                advices.endsWith("]")
            ) {
                try {
                    advices = JSON.parse(advices)
                } catch (error) {
                    console.error(
                        "Error parsing organization_advices as JSON:",
                        error
                    )
                }
            }

            return {
                title: "Organisation",
                icon: require("../../../assets/diagnostic/organisation/heure-de-grande-ecoute.png"),
                bulletPoints: advices,
                symbol: "💡",
                color: "#07276A",
            }

        case 5:
            return {
                title: "Compétence non maîtrisées",
                icon: require("../../../assets/diagnostic/priority/puzzle.png"),
                bulletPoints: data?.weakest_subject_analysis?.skill_gaps.map(
                    (gap) => gap?.competence
                ),
                symbol: "✗",
                color: "#BB1E10",
            }

        case 6:
            return {
                title: "Plan d'action",
                icon: require("../../../assets/diagnostic/objectif/task.png"),
                bulletPoints:
                    data?.weakest_subject_analysis?.objectif_actions || [],
                symbol: "✓",
                color: "#193366",
            }
    }
}

export const getStyleSeeMoreData = (data) => {
    const seeMoreData = data?.domain_analyses.map((info) => {
        return {
            domain: info?.domain || "",
            header: info?.diagnosis || "",
            comment: info?.teacher_remarks?.[0]?.remark || "",
            teacherName: info?.teacher_remarks?.[0]?.professor || "",
        }
    })

    return seeMoreData
}

export const getPageIcon = (pageData) => {
    if (pageData?.title === "Style") {
        return pageData?.icon[pageData?.style]
    }

    if (pageData?.title === "Matière Prioritaire") {
        switch (pageData?.prioritySubject) {
            case "maths":
                return require("../../../assets/diagnostic/priority/subjects/maths.png")
            case "français":
                return require("../../../assets/diagnostic/priority/subjects/french.png")
            case "anglais":
                return require("../../../assets/diagnostic/priority/subjects/english.png")
            case "mathématiques":
                return require("../../../assets/diagnostic/priority/subjects/maths.png")
            default:
                return pageData?.icon
        }
    }

    if (pageData?.title === "Performance" || !pageData?.isPillar) {
        return pageData?.icon
    }

    if (pageData?.isPillar) {
        return pageData?.icon[pageData?.score]
    }
}

export const getPageComment = (pageData) => {
    if (pageData?.title === "Matière Prioritaire") {
        return pageData?.comment[pageData?.level]
    }

    if (pageData?.title === "Performance" || !pageData?.isPillar) {
        return pageData?.comment
    }

    if (pageData?.isPillar) {
        return pageData?.comment[pageData?.score]
    }
}

export const getCTAData = (data) => {
    return {
        prioritySubject:
            data?.weakest_subject_analysis?.subject_name.toLowerCase() || "",
        studentAverage: data?.weakest_subject_analysis?.student_average || 0,
        objectifTarget: data?.weakest_subject_analysis?.objectif_target || 0,
    }
}

export const getColorMapping = () => {
    return {
        activeStrokeColor: {
            1: "#FF5252",
            2: "#FF9752",
            3: "#3D9970",
            4: "#00BFFF",
        },
        inActiveStrokeColor: {
            1: "#823838",
            2: "#9C5A2F",
            3: "#2A6B4F",
            4: "#0080B3",
        },
    }
}
